import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Updated Service titles and content
const services = [
  {
    title: "1. Doctor Consultation",
    content: `
1. DOCTOR CONSULTATION (ALLOPATHIC AND HOMEOPATHIC)
- DIABETIC /SUGAR CARE
- HYPERTENSIVE/ CARDIAC CARE
- JOINT PAIN/ORTHO CARE
- BACKACHE/PAIN IN LEG/NEURO CARE
- ALLERGY /ASTHMATIC CARE
- SKIN CARE
- INFECTION (FEVER/COLD/COUGH/PAIN IN ABDOMEN/ACIDITY/BURNING MICTURITION)
- TENSION CARE (HEADACHE/DECREASED SLEEP/GHABHARAHAT)
- PEDIATRIC CARE (IMMUNIZATION, DIET SCHEDULE OF CHILD FROM 6 MONTH ONWARD TO 5 YEARS AGE/PREVENTION OF SPECTACLE IN CHILDREN)
- PREGNANCY CARE (NO OF VISITS, INVESTIGATIONS, IMMUNIZATION, DIET AND LIFESTYLE, DETAILED CONSULTATION ABOUT PROBLEMS FACED DURING PREGNANCY, MOTHER AND FOETAL CARE)
- CARE OF BURN (HOT LIQUID)
- CARE OF HAIR (HAIR FALL/DANDRUFF)
- RIGHT APPROACH/GUIDANCE FOR ILLNESS FOR WHICH TREATMENT/RESULT IS NOT SATISFACTORY AFTER CONSULTING WITH MANY DOCTORS/HOSPITALS (GALL BLADDER STONE/KIDNEY STONE/PILES (HEMORRHOIDS)/SWELLING OR LUMP IN BREAST/DYSMENORRHEA OR IRREGULAR MENSTRUAL CYCLE OR FIBROID IN FEMALE/UNDERWEIGHT OR MALNOURISHED CHILDREN/GENETIC DISEASES IN CHILDREN)
`
},
{
  title: "2. Nursing Care",
  content: `
2. NURSING CARE
(remain in direct communication with our doctor)
- WOUND DRESSING AND CARE
- CARE OF PATIENT ON INJECTION/I/V INFUSION TREATMENT AT HOME
- CARE OF PATIENT ON RYLE’S TUBE/URINARY CATHETER/TRACHEOSTOMY (POST STROKE/PARALYSIS) AT HOME
- CARE OF PATIENT ON ENTERAL NUTRITION (POST OP GASTRIC SURGERY PATIENT) AT HOME
`
},
{
  title: "3. Dental Care",
  content: `
3. DENTAL CARE
- PAIN/BLEEDING/PUS IN TOOTH
- IRREGULAR FRONT TEETH
- TOOTH ERUPTION
`
}
,
{
  title: "4. Physiotherapy Care",
  content: `
4. PHYSIOTHERAPY CARE
(done with special device or instruments with trained skill and technique and remain always in touch with the patient until completely recovered mentally and physically)
- BEDRIDDEN PATIENT(POST CVA/STROKE/PARALYSIS)
- FROZEN SHOULDER
- POST SURGERY REHABILITATION (TKR/THR/SPINE SURGERY/NEUROSURGERY/FRACTURE)
- POST HEART ATTACK CARE
- RESPIRATORY DISEASE (ASTHMA/DIFFICULTY IN BREATHING)
- ORTHO (ARTHRITIS/BACKACHE/DIFFICULTY IN WALKING/CERVICAL SPONDYLYTIS)
`
}
,
{
  title: "5. Mental Care",
  content: `
5. MENTAL CARE (PSYCHIATRIST AND PSYCHOTHERAPIST)
--------patient feels like he/she is talking with his/her family member------
--------emotional and mental support is an easier tool than medicine------
- DECREASED SLEEP/ NO SLEEP
- IRRITATION/ ANGRYNESS
- MIND FLUCTUATION
- NOT ABLE TO TAKE DECISION FOR DAILY TASK
- NOT ABLE TO CONCENTRATE ON STUDY/WORK
- DULL/UNHAPPY MOOD/ NO INTEREST IN ENJOYABLE MOMENTS
- MANY UNWANTED THOUGHTS CIRCULATE IN MIND AND WANT TO SHARE THEM
- HOW TO DEAL WITH SURROUNDING ENVIRONMENT IN YOUR HOME AND OUTSIDE
- CONFUSION ABOUT RIGHT OR WRONG THINGS/FACT/DECISION
`
}
,
{
  title: "6. Pregnancy Care",
  content: `
6. PREGNANCY CARE (PRENATAL/NATAL/POSTNATAL)
.....care of the most precise moment/time of any female.....
- NO. OF VISITS/CHECKUPS DURING PREGNANCY
- TIMELY INVESTIGATIONS DURING PREGNANCY (to early diagnose congenital abnormalities (like Down syndrome/neural tube defects) and early diagnose and manage medical illnesses common during pregnancy (like thyroid, anaemia, diabetes, hypertension, oligo or polyhydramnios) and prevent complications, hospitalization, and unnecessary cesarean sections).
- IMMUNIZATION
- DETAILED CONSULTATION ABOUT PROBLEMS FACED DURING PREGNANCY
- MOTHER AND FETAL CARE
- DIET AND LIFESTYLE/ACTIVITY/WORK/YOGA DURING PREGNANCY (PREVENT HYPERTENSION, PROPER WEIGHT GAIN OF MOTHER, RELAXATION OF FETUS)
`
}
,
{
  title: "7. Elderly Care",
  content: `
7. ELDERLY CARE
..........prevention is better than cure..........
..........you forget, but we don’t...........
- ON 1ST VISIT – FREE DOCTOR VISIT/EYE CHECKUP/DENTIST VISIT AND ALL REQUIRED MEDICAL CHECKUPS, THEN ACCORDINGLY PLAN THEIR DIET, MEDICATION, AND DAILY ACTIVITY, FOLLOWED BY MONTHLY DOCTOR VISITS FOR GENERAL CHECKUPS, AND IF REQUIRED, EMERGENCY DOCTOR VISITS....
- SPECIAL DISCOUNT ON MEDICATION, LAB TESTS, MEDICAL EQUIPMENT
- IN CASE OF HOSPITALIZATION FOR MEDICAL ILLNESS...OUR DOCTOR CONSULTS WITH THE TREATING DOCTOR AND ASSISTS YOU IN ANY WAY POSSIBLE....
- IN CASE OF ANY SURGERY/SURGICAL RELATED PROBLEMS, OUR DOCTOR IS ALWAYS WITH YOU LIKE A FAMILY MEMBER AND WILL ASSIST YOU IN ANY WAY POSSIBLE....
- POST-SURGERY (HEART ATTACK (PTCA), NEUROSURGERY, ORTHO SURGERY, etc.), WE TAKE RESPONSIBILITY FOR MEDICATION MANAGEMENT, ACTIVITY, AND ANY EMERGENCY IF REQUIRED....
`
}
,
{
  title: "8. Homeopathic Care",
  content: `
8. HOMEOPATHIC CARE (better than allopathic/long-term expenditure)
- SKIN DISEASE (ECZEMA/PSORIASIS/TINEA/SKIN ERUPTION/URTICARIA/INSECT BITE)
- KIDNEY STONE/GALL BLADDER STONE (UNCOMPLICATED MEDICAL INDICATION)
- GYNECOLOGICAL CONDITIONS (MENO/METRORRHAGIA/UTERINE FIBROID)
- HAEMORROIDS/PILES
- HAIRFALL/DANDRUFF
- BEDRIDDEN PATIENT (POST CVA/STROKE/PARALYSIS)
- FROZEN SHOULDER
- POST-SURGERY REHABILITATION (TKR/THR/SPINE SURGERY/NEUROSURGERY/FRACTURE)
`
}
,
{
  title: "9. Medical Equipment",
  content: `
9. MEDICAL EQUIPMENT
I. GENERAL
- THERMOMETER (MERCURY/ELECTRONIC)
- SPHYGMOMANOMETER (B.P MONITOR MACHINE) (MANUAL/ELECTRONIC)
- GLUCOMETER (SUGAR MEASUREMENT MACHINE)
- I/V STAND
- ICU BED/RECLINER BED
- AIR BED MATTRESS
- DVT PUMP

II. RESPIRATORY CARE
- STEAM INHALER
- NEBULIZER
- PULSE OXYMETER
- RESPIROMETER
- OXYGEN MASK WITH OXYGEN CYLINDER
- SUCTION APPARATUS
- CPAP/BIPAP/ADVANCED HOME CARE VENTILATOR

III. CARDIAC CARE
- ECG MACHINE
- MULTIPARA MONITOR
- INFUSION PUMP/SYRINGE PUMP

IV. BABY CARE
- BREAST PUMP
- BOTTLE STERILIZER
- PEDIATRIC PULSE OXYMETER
- BABY WEIGHT SCALE

V. GERIATRIC CARE
- WALKING STICK/CRUTCHES/QUADRUPED STICK
- WHEELCHAIR/WALKER

VI. ORTHO CARE
- CERVICAL COLLAR/NECK BELT
- LUMBOSACRAL BELT/LOWER BACK BRACE/POSTURE SUPPORT BRACE
- TLO/CTLO BRACE (SCOLIOSIS)
- KNEE IMMOBILIZER/BRACE/SUPPORT
- ANKLE BRACE/SUPPORT
- TIBIO-FIBULAR-ANKLE-FOOT BRACE
- SHOULDER IMMOBILIZER/SUPPORT
- CLAVICLE BRACE/SUPPORT
- WRIST-FOREARM/THUMB/FINGER/TOE/ELBOW SPLINT
- HEEL-FOOT PROTECTOR/SOCKS
- PLANTAR FASCITIS REINFORCED ARCH/SUPPORT
`
}
,
{
  title: "10. Lab Test & Medical Checkup",
  content: `
10. LABORATORY TEST AND MEDICAL CHECKUP
(early diagnosis and treatment is the best level of management of disease and prevents complications/unnecessary treatment/hospitalization)
- BASIC/YEARLY HEALTH CHECKUP (HB/BLOOD SUGAR - FBS-PPBS-HBA1C/THYROID PROFILE/LIPID PROFILE-CHOLESTEROL/LIVER-KIDNEY FUNCTION TEST/URINE EXAM-CUE/USG ABDOMEN)
- FEVER PANEL (CBC/ESR/MALARIA/TYPHOID/DENGUE/URINE EXAM)
- BASIC BONE/JOINT PAIN CHECKUP (CBC/ESR/CALCIUM/PHOSPHATE/VITAMIN D/ALP/ALBUMIN/URIC ACID/RA FACTOR/CRP/PARATHYROID - PTH)
- CANCER SCREENING PANEL (CEA/AFP/BETA-HCG/CA-125/CA 19-9/THYROGLOBULIN/STOOL FOR OCCULT BLOOD/USG WHOLE ABDOMEN/PAP SMEAR)
`
}
,
  {
    title: "11. Ambulance Service",
    content: `EMERGENCY PICKUP
24/7 SERVICE
FULLY EQUIPPED AMBULANCES WITH MEDICAL TEAM`,
  },
  {
    title: "12. Referral to Hospital",
    content: `DIRECT REFERRAL TO SPECIALISTS
TIE-UP WITH LOCAL HOSPITALS FOR BETTER TREATMENT OPTIONS`,
  },
];

const Services = () => {
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ padding: 4, minHeight: "100vh", backgroundColor: "#f4f6f8" }} id="service" className="mt-5 pt-5">
      <Paper sx={{ width: "100%", padding: 4 }}>
        <Typography
          variant="h4"
          align="center"
          sx={{ marginBottom: "30px", fontWeight: "bold" }}
        >
          Doctor Service At Home
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            fontSize: "16px",
            textAlign: "center",
            whiteSpace: "pre-line",
          }}
        >
          {`Why We Need Home Medical Service in the Present Situation:
          Due to changes in family structure, most elderly couples live in flats or societies alone and depend on neighbors for medical emergencies. 
          We offer the best-trained medical staff and doctors to care for you at home.`
          }
        </Typography>

        {services.map((service, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleAccordionChange(`panel${index}`)}
            sx={{ marginBottom: "10px", borderRadius: "6px" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              className="acc-item"
            >
              <Typography variant="h6">{service.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography whiteSpace="pre-line">{service.content}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Paper>
    </Box>
  );
};

export default Services;
